import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import SaveIcon from '@material-ui/icons/Save';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import DescriptionIcon from '@material-ui/icons/Description';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    alignContent:'right',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

//****************************************************************carregar tipos veiculo***************** */

var datahoraretorno;
var datahorasaida;
var depsolicitente;
var dsolicitacao;
var nomesolicitante;
var lotacaosolicitante;
var telefonesolicitante;
var objetivo;
var nsolicitacao;
var npassageiro;
var siapesolicitente;
var listaparadas=[];
var listapassageiros=[];
var localdestino=[];
var localsaida=[];
var lotacao='';
var utipo='';
var depnome='';
     
 export default function RecipeReviewCard(props) {
   //**********************carrega motorista */
   const [state,setState]=React.useState([]);
   const [stateveiculo,setStateveiculo]=React.useState([]);
  /* React.useEffect(() => {
    
   

    async function pegauser() {
      const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
       var userref =  db.collection("usuarios").doc(user.uid);         
       console.log("esta aqui 001");
      await userref.get().then((doc) => {       
         if (doc.exists) {
           console.log("Document data pegouppqpq:", doc.data());
           utipo = doc.data().usertipo;
           lotacao = doc.data().lotacao;
           depnome=doc.data().depnome;
            console.log('porraaaaa' , doc.data().lotacao);
            pegalistamotorista();
            pegalista();
         }else{
           alert('Não encontramos o seu cadastro')
         }
        
        }).catch(function(error) {
          alert("Erro ao localizar o seu cadastro ", error.message);
          })
    };

    async function pegalista() {          
      if(utipo==3) {
       console.log("user tipo poxa"+ lotacao + "puta merda");
       var db = firebase.firestore();
       var query = await db.collection("veiculos").where("lotacao", "==", lotacao).get()
       .then(function(querySnapshot) {
       
        querySnapshot.forEach(function(doc) {
          var listaveiculos1=[];
            listaveiculos1.push({id: doc.id, modelo: doc.data().modelo,
              placa:doc.data().placa, anofab: doc.data().ano, km: doc.data().km,
            marca: doc.data().marca, lotacao: doc.data().lotacao, status: doc.data().status,
          tipoveiculo: doc.data().tipoveiculo ,npassageiros: doc.data().npassageiros, capcarga: doc.data().capacidadecarga});
          console.log("veiculos pqp ", state );
         setState (currentArray => [...currentArray, listaveiculos1]);
         

        });
       
      })
     .catch(error => {
         console.log('Não encontramos veículos cadastrados', error);
     });
     
     }else {
     
      await firebase.firestore().collection("veiculos").get()
     .then(function(querySnapshot) {
       
       querySnapshot.forEach(function(doc) {
         var listaveiculos1=[];
           listaveiculos1.push({id: doc.id, modelo: doc.data().modelo,
             placa:doc.data().placa, anofab: doc.data().ano, km: doc.data().km,
           marca: doc.data().marca, lotacao: doc.data().lotacao, status: doc.data().status,
         tipoveiculo: doc.data().tipoveiculo , npassageiros: doc.data().npassageiros, capcarga: doc.data().capacidadecarga});
         console.log("veiculos pqp ", state );
        setStateveiculo (currentArray => [...currentArray, listaveiculos1]);
        

       });
      
     })
     .catch(error => {
         console.log('Não encontramos veículos cadastrados', error);
     });
     
      
     }

   


}

    async function pegalistamotorista() {          
      
            if(utipo==3) {
             console.log("user tipo poxa"+ lotacao + "puta merda");
             var db = firebase.firestore();
             var query = await db.collection("motoristas").where("lotacao", "==", lotacao).get()
             .then(function(querySnapshot) {
        
              querySnapshot.forEach(function(doc) {
                var listausers=[];
                  listausers.push({id: doc.id, nome: doc.data().nome,
                    matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
                  usertipo: doc.data().usertipo, lotacao: doc.data().lotacao, depnome: doc.data().depnome,
                  cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
                email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data.vencimentoCNH , novo:false
              });
                console.log("veiculos pqp ", state );
               setState (currentArray => [...currentArray, listausers]);
               
     
              });//***********************
              
                      
            })
           .catch(error => {
               console.log('Não encontramos motoristas cadastrados', error);
               alert("'Não encontramos motoristas cadastrados'");
           });
           
           }else {
           
            await firebase.firestore().collection("motoristas").get()
            .then(function(querySnapshot) {
        
              querySnapshot.forEach(function(doc) {
                var listausers=[];
                  listausers.push({id: doc.id, nome: doc.data().nome,
                    matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
                  usertipo: doc.data().usertipo, lotacao: doc.data().lotacao, depnome: doc.data().depnome,
                  cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
                email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data.vencimentoCNH, novo:false });
                console.log("veiculos pqp ", state );
               setState (currentArray => [...currentArray, listausers]);
               
     
              });
             
            })
           .catch(error => {
               console.log('Não encontramos motoristas cadastrados', error);
               alert("'Não encontramos motoristas cadastrados'");
           });
           
            
           }
     
           
         
    
      
    }
 
    pegauser()
    
  
  
  console.log('agora sim é o tamanho ', state.length);
  }, []); 
*/


//********************objeto veiculo******************* */

const [itemagenda, setitemagenda] = React.useState([]);

React.useEffect(() => {
  console.log("item agend props ", props)
  
setitemagenda(props.props);


itemagenda.forEach(modelo=>(datahoraretorno=modelo.datahoraretorno))
//setlot(lota);
itemagenda.forEach(modelo=>(datahorasaida=modelo.datahorasaida))
//setlot(lota);
itemagenda.forEach(modelo=>(depsolicitente=modelo.depsolicitente));
//setStateautcomp(tipo);
//console.log('valor do stateauco ',stateautcomp)
itemagenda.forEach(modelo=>(dsolicitacao=modelo.dsolicitacao))
//console.log('valor do status',st)
itemagenda.forEach(modelo=>(nomesolicitante=modelo.nomesolicitante))
//setlot(lota);
itemagenda.forEach(modelo=>(lotacaosolicitante=modelo.lotacaosolicitante))
//setlot(lota);
itemagenda.forEach(modelo=>(telefonesolicitante=modelo.telefonesolicitante))
//setlot(lota);
itemagenda.forEach(modelo=>(objetivo=modelo.objetivo))
//setlot(lota);
itemagenda.forEach(modelo=>(nsolicitacao=modelo.nsolicitacao))

//setlot(lota);
itemagenda.forEach(modelo=>(npassageiro=modelo.npassageiro))
//setlot(lota);
itemagenda.forEach(modelo=>(siapesolicitente=modelo.siapesolicitente))
//setlot(lota);
itemagenda.forEach(modelo=>(listaparadas=modelo.listaparadas))
//setlot(lota);
itemagenda.forEach(modelo=>(listapassageiros=modelo.listapassageiros))
//setlot(lota);
itemagenda.forEach(modelo=>(localdestino=modelo.localdestino.description))
console.log('destino', localdestino )
itemagenda.forEach(modelo=>(localsaida=modelo.localsaida.description))
//setlot(lota);

  //setState({...state,checkmanobra:st})
 


},[itemagenda]);





      
                    //********************************** */

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
    if(expanded){
    
  }};

  return (
    <Card className={classes.root} >
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <DriveEtaIcon />
               </Avatar>
             }
            
             title= {itemagenda.map(modelo=>(modelo.nsolicitacao))}
             subheader= {itemagenda.map(modelo=>(modelo.dsolicitacao))}
     
           />
           <CardContent>
           <Typography variant="body2" color="textSecondary" component="p">
               Departamento: {itemagenda.map(modelo=>(modelo.depsolicitente))}
             </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
               Campi: {itemagenda.map(modelo=>(modelo.lotacaosolicitante))}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Nome Solicitante: {itemagenda.map(modelo=>(modelo.nomesolicitante))}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Objetivo: {itemagenda.map(modelo=>(modelo.objetivo))}
             </Typography>
             
             <Typography variant="body2" color="textSecondary" component="p">
               Data de Saída: {itemagenda.map(modelo=>(modelo.datahorasaida))}
             </Typography>
             
             
            

           </CardContent>

          
            <CardActions disableSpacing>
            <Tooltip title="Salvar">
            <IconButton id="btsalvar" aria-label="Salvar" //disabled={edita} type="submit" //onClick={handlesalvar}
            >
               <SaveIcon />
             </IconButton>
             </Tooltip>
             <Tooltip title="Notificar">
             <IconButton id="btnotificar" aria-label="notificar" //disabled={botaoedit} //onClick={handleeditar}
             >
               <AddAlertIcon />
             </IconButton>
             </Tooltip>
             <Tooltip title="Aprovar">
             <IconButton id="btaprovar" aria-label="aprovar" //disabled={botaoedit} //onClick={handleeditar}
             >
               <CheckCircleOutlineIcon />
             </IconButton>
             </Tooltip>
             <Tooltip title="Cancelar">
             <IconButton id="btcancelar" aria-label="cancelar" // disabled={botaoedit} //onClick={handleeditar}
             >
               <HighlightOffIcon />
             </IconButton>
             </Tooltip>
            
     
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           <Collapse in={expanded} timeout="auto" unmountOnExit>
             <CardContent>
             <Typography variant="body2" color="textSecondary" component="p">
               Local de Saída: {localsaida}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Destino: {localdestino}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Data de retorno: {itemagenda.map(modelo=>(modelo.datahoraretorno))}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Nº Passageiros: {itemagenda.map(modelo=>(modelo.npassageiro))}
             </Typography>

             <Autocomplete
                 
                 id="comboveiculo"
                 options={stateveiculo}
                 getOptionLabel={(option) => option.label}
                 
                 renderInput={(params) => <TextField {...params}   required label="Veículos" variant="outlined" />}
               />
                <Autocomplete
                 
                 id="combomotorista"
                 options={state}
                 getOptionLabel={(option) => option.label}
                 
                 renderInput={(params) => <TextField {...params}   required label="Motorista" variant="outlined" />}
               />
     
             </CardContent>
             <CardActions disableSpacing>
             <Tooltip title="Ordem de Trânsito">
             <IconButton id="btsalvar" aria-label="Salvar" //disabled={edita} type="submit" //onClick={handlesalvar}
            >
               <LocalShippingIcon />
             </IconButton>
            </Tooltip>
            <Tooltip title="CheckList">
             <IconButton id="btnotificar" aria-label="notificar" //disabled={botaoedit} //onClick={handleeditar}
             >
               <AssignmentTurnedInIcon />
             </IconButton>
             </Tooltip>
             <Tooltip title="Relatório de Viagem">
             <IconButton id="btaprovar" aria-label="aprovar" //disabled={botaoedit} //onClick={handleeditar}
             >
               <DescriptionIcon />
             </IconButton>
             </Tooltip>
             <Tooltip title="Anexos">
             <IconButton id="btcancelar" aria-label="cancelar" // disabled={botaoedit} //onClick={handleeditar}
             >
               <AttachmentIcon />
             </IconButton>
             </Tooltip>
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           </Collapse>
         </Card>
  );
}